var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_672_1953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.82342 7.47656L1.29291 14.602L8.41831 12.0781",
    stroke: "#90A1B9",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.62476 1.94922H2.63142",
    stroke: "#90A1B9",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6114 5.2793H14.6181",
    stroke: "#90A1B9",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94992 1.28369H9.95658",
    stroke: "#90A1B9",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6114 13.27H14.6181",
    stroke: "#90A1B9",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6114 1.28369L13.1197 1.78314C12.6951 1.92457 12.3328 2.20909 12.0947 2.58805C11.8567 2.96702 11.7576 3.41691 11.8145 3.86082C11.8811 4.43352 11.4349 4.94628 10.8489 4.94628H10.5959C10.0232 4.94628 9.53039 5.34583 9.42384 5.90521L9.284 6.61109",
    stroke: "#90A1B9",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6114 8.60885L14.0654 8.38909C13.4927 8.16268 12.8534 8.52227 12.7468 9.12827C12.6736 9.59441 12.2674 9.9407 11.7946 9.9407H11.2818",
    stroke: "#90A1B9",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28623 1.28369L7.50598 1.82975C7.7324 2.40245 7.3728 3.04173 6.7668 3.14828C6.30066 3.21487 5.95438 3.62775 5.95438 4.10055V4.61332",
    stroke: "#90A1B9",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28622 8.60849C8.57146 9.89372 9.17079 11.3854 8.61808 11.9381C8.06536 12.4908 6.57369 11.8915 5.28845 10.6063C4.00321 9.32103 3.40388 7.82936 3.9566 7.27664C4.50932 6.72392 6.00099 7.32325 7.28622 8.60849Z",
    stroke: "#90A1B9",
    strokeWidth: 1.33185,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_672_1953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9822,
    height: 15.9822,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.3d8a373c57f79cabe9f957b4c60e6237.svg";
export { ForwardRef as ReactComponent };